import i18n, { i18nNS } from '../../i18n';
import request from '../request';
import { ToBeDone } from '../types';
import { ClassActivityAPI } from './api-types';
import urls from './urls';

export async function getUnpublishedActivities<T>(
  payload: ClassActivityAPI.GetUnpublishedActivitiesRequest
): Promise<ClassActivityAPI.GetUnpublishedActivitiesResponse<T>> {
  const { data } = await request.get<ClassActivityAPI.GetUnpublishedActivitiesResponse<T>>(
    urls.getUnpublishedActivities(payload.classId, payload.activityType),
    {
      headers: { courseId: payload.courseId },
    }
  );

  const { message } = data;
  if (message !== 'success') throw new Error(i18n.t('unable_to_fetch_polls', { ns: i18nNS.POLL }));

  return data;
}

export async function getPreviouslyUsedActivities<T>(
  payload: ClassActivityAPI.GetPreviouslyUsedActivitiesRequest
): Promise<ClassActivityAPI.GetPreviouslyUsedActivitiesResponse<T>> {
  const { data } = await request.get<ClassActivityAPI.GetPreviouslyUsedActivitiesResponse<T>>(
    urls.getPreviouslyUsedActivities(payload.activityType)
  );

  const { message } = data;
  if (message !== 'success') throw new Error(i18n.t('unable_to_fetch_polls', { ns: i18nNS.POLL }));

  return data;
}

export async function copyActivity(
  payload: ClassActivityAPI.CopyActivityRequest
): Promise<ClassActivityAPI.CopyActivityResponse> {
  const { activityId, activityType, destinationClassId, destinationCourseId, sourceCourseId } = payload;
  const transformedPayload: ClassActivityAPI.CopyActivityTransformedRequest = {
    activityId,
    activityType,
    toBeDone: ToBeDone.IN_CLASS,
    copyToClass: destinationClassId,
    copyToCourse: destinationCourseId,
  };

  const { data } = await request.post<ClassActivityAPI.CopyActivityResponse>(
    urls.copyActivity,
    transformedPayload,
    sourceCourseId
      ? {
          headers: { courseId: sourceCourseId },
        }
      : undefined
  );

  return data;
}
